<template>
  <div class="container-fluid d-flex align-items-center justify-content-center vh-100">
    <div class="w-100">
    <div class="row justify-content-center">
    <div class="col-3 my-3 text-center">
      <img width="300" alt="Health Here" src="../assets/health-here-logo.svg"/>
    </div>
    </div>
    <div class="col">
      <b-alert v-if="generalErrorMessage" :show="true" fade variant="danger">
        {{ generalErrorMessage }}
      </b-alert>
    </div>
    <div class="row justify-content-center">
      <div class="col-3">
        <b-card>
        <h4>Two-Factor Authentication</h4>
          <p>
          <span v-if="!isRecoveryCode">
            Enter the 6-digit code from your authenticator app to continue
          </span>
          <span v-else>Enter your recovery code.</span>
          </p>

        <b-form class="mt-3">
          <b-form-group :state="stateForField('code')" :invalid-feedback="errorForField('code')" :label="isRecoveryCode ? 'Recovery code' : ''">
            <div v-if="!isRecoveryCode" class="d-flex justify-content-between">
              <input
                  v-for="(digit, index) in codeArray"
                  :key="index"
                  autofocus
                  ref="codeInputs"
                  class="form-control text-center mx-1 code-input"
                  maxlength="1"
                  v-model="codeArray[index]"
                  @input="onInput(index)"
                  @keydown.backspace="onBackspace(index)"
                  @paste="onPaste"
              />
            </div>
            <b-form-input
                v-else
                v-model="code"
                placeholder="Enter your recovery code"
                class="mt-1"
            />
          </b-form-group>

          <b-form-group>
            <b-form-checkbox v-model="isRecoveryCode">
              Use a recovery code instead
            </b-form-checkbox>
          </b-form-group>
          <button type="submit" @click.prevent="submit()" class="btn btn-orange btn-block">Verify</button>
        </b-form>
        </b-card>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'
  import api from '@/services/api'
  export default {
    name: 'TwoFactor',
    mixins: [ErrorsMixin, AnalyticsMixin],
    props: {
      token: {
        type: String,
        required: false
      }
    },
    data () {
      return {
        isRecoveryCode: false,
        codeArray: ['', '', '', '', '', ''],
        isSaving: false,
        code: ''
      }
    },
    computed: {
      finalCode () {
        return this.isRecoveryCode ? this.code : this.codeArray.join('')
      }
    },
    methods: {
      onInput (index) {
        const value = this.codeArray[index]
        this.codeArray[index] = value.replace(/[^0-9]/g, '')
        if (value && index < 5) {
          this.$refs.codeInputs[index + 1].focus()
        }
      },
      onPaste (event) {
        event.preventDefault()

        const pastedData = event.clipboardData.getData('text').trim()

        if (!pastedData) return

        const digits = pastedData.split('')

        digits.forEach((digit, i) => {
          if (i < this.codeArray.length) {
            this.$set(this.codeArray, i, digit)
          }
        })

        const lastIndex = Math.min(digits.length - 1, this.codeArray.length - 1)
        const inputs = this.$refs.codeInputs

        if (inputs && inputs[lastIndex]) {
          inputs[lastIndex].focus()
        }
      },

      onBackspace (index) {
        if (!this.codeArray[index] && index > 0) {
          this.$refs.codeInputs[index - 1].focus()
        }
      },

      validate () {
        this.clearAllErrors()

        if (!this.finalCode) {
          this.addErrorForField('code', 'Code is required')
        }
        return !this.hasErrors()
      },
      submit () {
        this.clearAllErrors()
        if (this.isSaving) return

        if (!this.validate()) {
          return
        }
        this.isSaving = true

        const code = this.isRecoveryCode ? this.code : this.finalCode
        const parameters = {
          pendingToken: this.token,
          totpCode: code,
          isRecoveryCode: this.isRecoveryCode
        }
        api.post('/Auth/VerifyTotp', parameters).then(response => {
          const data = response.data
          this.isSaving = false
          this.$store.userAuthenticated(
            {
              email: data.email,
              firstName: data.firstName,
              lastName: data.lastName,
              idToken: data.idToken,
              organizationId: data.organizationId,
              roles: data.roles
            },
            null, () => { this.$router.push(this.$store.homePagePath) })
        }).catch(error => {
          this.isSaving = false
          const data = error.response?.data
          if (data?.totp_failure) {
            error.response.data = { code: data.totp_failure }
          }
          this.setFromApiErrorResponse(error)
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error confirming 2FA: ' + error.message, error)
          }
        })
      }
    }
  }
</script>

<style scoped>
.card {
  border: none;
}
</style>
